
import { FunctionArgumentType, FunctionPlugin } from './FunctionPlugin';
export class PowerPlugin extends FunctionPlugin {
    power(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('POWER'), Math.pow);
    }
}
PowerPlugin.implementedFunctions = {
    'POWER': {
        method: 'power',
        parameters: [
            { argumentType: FunctionArgumentType.NUMBER },
            { argumentType: FunctionArgumentType.NUMBER },
        ],
    },
};
